<template>
  <div class="queueItem">
    <div class="queueItem__meetType">
      <span class="queueItem__meetType--text textOverflow">
        {{ item.meetType }}
      </span>
    </div>
    <div class="queueItem__middle">
      <div class="queueItem__middle--left">
        <div class="queueItem__profileImage">
          <PictureCircle />
          <div
            :class="`queueItem__statusIcon${
              item.patient.isOnline ? ' online' : ''
            }`"
          />
        </div>
        <div class="queueItem__patientStatus">
          {{ item.patient.isOnline ? 'Online' : 'Offline' }}
        </div>
      </div>
      <div class="queueItem__middle--right">
        <span class="queueItem__generalInfos">
          <div class="queueItem__generalInfo">
            <div
              class="queueItem__generalInfo--text textOverflow"
              :title="item.clinic.name"
            >
              {{ item.clinic.name }}
            </div>
          </div>
          <pre> | </pre>
          <div class="queueItem__generalInfo">
            <div
              class="queueItem__generalInfo--text textOverflow"
              :title="item.specialty"
            >
              {{ item.specialty }}
            </div>
          </div>
        </span>
        <div class="queueItem__patientName">
          <div
            class="queueItem__patientName--text textOverflow"
            :title="item.patient.name"
          >
            {{ item.patient.name }}
          </div>
        </div>
        <div class="queueItem__patientAge">{{ item.patient.age }} anos</div>
      </div>
    </div>
    <div class="queueItem__requester">
      <div class="queueItem__requester--text textOverflow">
        Solicitante: {{ item.requester.name }}
      </div>
    </div>
    <div class="queueItem__bottom">
      <div
        :class="`queueItem__waitingTime ${!item.schedulingDate ? ' hide' : ''}`"
      >
        A
        <strong class="queueItem__waitingTime--time">
          {{ waitingTime }}
        </strong>
        na fila
      </div>
      <div class="queueItem__actions">
        <button
          :class="`queueItem__action${loadingQueueAction ? ' loading' : ''}`"
          @click="currAction.handler"
        >
          <span class="queueItem__action--text">
            {{ currAction.label }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PictureCircle from '@/components/PictureCircle';
import moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  name: 'QueueItem',
  components: { PictureCircle },
  props: {
    item: {
      default: null,
      type: Object,
    },
  },

  computed: {
    ...mapState('queue', {
      loadingQueueAction: ({ loadingQueueAction }) => loadingQueueAction,
    }),
    ...mapGetters('dashboard', ['currWorkspace']),
    waitingTime() {
      const now = moment(),
        { schedulingDate } = this.item;

      return `${now.to(schedulingDate, true)}`;
    },

    currAction() {
      const {
        item,
        currWorkspace,
        openMeeting,
        acceptInterconsultation,
        acceptQueue,
      } = this;
      let label, handler;

      if (item.meetingId) {
        if (currWorkspace.professionalId == item.professionalId) {
          label = 'Abrir';
          handler = () => openMeeting(item.meetingId);
        } else {
          label = 'Iniciar';
          handler = acceptInterconsultation;
        }
      } else {
        label = 'Aceitar';
        handler = () => acceptQueue(item.id);
      }

      return { label, handler };
    },
  },

  methods: {
    ...mapActions('queue', [
      'openMeeting',
      'acceptQueue',
      'acceptInterconsultation',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
